import { alpha, createTheme } from '@mui/material';

import {
  brandPalette,
  errorPalette,
  greenPalette,
  greyPalette,
  successPalette,
  warningPalette,
} from './colors';
import { getMainThemeOptions } from './mainThemeOptions';

const theme = createTheme({
  spacing: 8,
  shape: {
    borderRadius: 10,
  },
  palette: {
    mode: 'dark',
    action: {
      selected: alpha('#000', 0.15),
    },
    customMain: greenPalette,
    primary: {
      main: greenPalette[500],
    },
    secondary: {
      main: '#000',
    },
    brand: brandPalette,
    background: {
      default: '#131315',
      paper: 'rgba(27, 28, 29, 0.60)',
    },
    text: {
      primary: '#FFF',
      secondary: '#CFDDF1',
    },
    grey: greyPalette,
    divider: greyPalette[50],
    success: {
      ...successPalette,
      main: successPalette[500],
      light: successPalette[400],
    },
    warning: {
      ...warningPalette,
      main: warningPalette[500],
      light: warningPalette[400],
    },
    error: {
      ...errorPalette,
      main: errorPalette[600],
      light: errorPalette[400],
    },
  },
});

const mainThemeOptions = getMainThemeOptions(theme);

export const darkTheme = createTheme({
  ...mainThemeOptions,
  components: {
    ...mainThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        ...mainThemeOptions.components?.MuiButton?.styleOverrides,

        textPrimary: {
          color: greenPalette[550],

          '&:hover': {
            backgroundColor: 'transparent',
          },
        },

        containedPrimary: {
          backgroundColor: '#131315',
          color: theme.palette.common.white,
          borderRadius: '1000px',

          boxShadow: `
              0 0 0 0 rgba(33, 78, 129, 0.6), 
              0 0 20px rgba(255, 203, 103, 0.4)
          `,

          '&:before': {
            content: "''",
            position: 'absolute',
            inset: '-1px',
            zIndex: -1,
            borderRadius: 'inherit',

            background: `
            linear-gradient(
                  90deg,
                  rgba(33, 78, 129, 1) 0%,
                  rgba(31, 65, 97, 1) 25%,
                  rgba(237, 84, 9, 1) 75%,
                  rgba(255, 203, 103, 1) 100%
            )`,
          },

          '&:hover': {
            backgroundColor: 'rgba(237, 84, 9, 1)',
          },
        },

        containedSecondary: {
          backgroundColor: greyPalette[800],
          color: theme.palette.common.white,
          borderRadius: '1000px',

          '&:hover': {
            backgroundColor: greyPalette[900],
          },

        },

        outlinedPrimary: {
          borderColor: 'transparent',
          color: theme.palette.common.white,
          backgroundColor: theme.palette.background.paper,

          '&:hover': {
            backgroundColor: theme.palette.common.white,
            borderColor: 'transparent',
            color: greenPalette[900],
          },
        },
      },
    },
  },
});
